import {consoleLogger} from '@gongxigames/framework/core';
import {GenericPopupConfig, GenericPopupData} from '@gongxigames/framework/slot/types';
import {GenericPopupEvents} from '@gongxigames/framework/slot/modules/genericPopup/GenericPopupEvents';
import {
    GenericPopupModule,
    GenericPopupModuleEvents
} from '@gongxigames/framework/slot/modules/genericPopup/GenericPopupModule';
import {GenericPopupType} from '@gongxigames/framework/slot/modules/genericPopup/GenericPopupType';
import {GenericPopupView} from '@gongxigames/framework/slot/modules/genericPopup/GenericPopupView';
import {slotStore, strictGameEmitter} from '@gongxigames/framework/slotV2/globals';
import {ModuleState} from '@gongxigames/framework/slot';

export class GenericPopupBasicState extends ModuleState<GenericPopupView, GenericPopupModule, GenericPopupModuleEvents> {
    public onEnterState(): void {
        this.module.slotEventAdapter.emit('General.UI.ENABLE', GenericPopupModule.NAME);
    }

    public onLeaveState(): void {
        this.module.slotEventAdapter.emit('General.UI.DISABLE', GenericPopupModule.NAME);
    }

    protected setupEvents(): void {
        this.setEventHandler('General.Popup.SHOW', this.onShowPopup.bind(this));
        this.setEventHandler(GenericPopupEvents.SHOW_POPUP, this.onShowEvent.bind(this));
    }

    protected showPopup(config: GenericPopupConfig, data?: GenericPopupData): void {
        this.checkAutoSkipFeature(config);
        this.module.setupView(config.view);
        this.view.initPopup(config, data);
        this.module.gotoState(GenericPopupModule.SHOWING_STATE);
    }

    protected onShowPopup(data: GenericPopupData): void {
        const {popupConfig} = this.module.gameConfig;
        let config = popupConfig?.find(value => value.type === data.type);

        if (config) {
            if (data.counterValue?.type) {
                const {type} = data.counterValue;
                const newConfig = this.module.createConfigWithTypedAnimations(config, type);

                this.module.playTypedAnimationSounds(config, type);
                config = newConfig;
            }

            this.showPopup(config, data);
        }
    }

    protected checkAutoSkipFeature(config: GenericPopupConfig): void {
        // TODO leave this section , cause there is a possibility to implement it further
        /* if (slotStore.reelsSpeedLevel.value === ReelsSpeedLevel.turbo_2) {
            const reelSpeedLevel = slotStore.reelsSpeedLevel.value;
            const speedSettings = this.module.gameConfig.reelsConfig.reelsSpeedLevels[reelSpeedLevel];

            if (speedSettings?.autoClosePopupTimeout > 0) {
                config.closeTimeout = speedSettings.autoClosePopupTimeout;
            }
        } else */if (slotStore.feature_autoCloseScreensEnabled.value) {
            config.closeTimeout = this.module.gameConfig.reelsConfig.autoClosePopupTimeout;
        }

    }

    protected onShowEvent(type: Symbol, value?: string, ...args: any[]): void {
        const config = this.module.getConfigByType(type, value, ...args);

        // TODO refactor this case
        if (!config) {
            if (type === GenericPopupType.FREESPIN_OUTRO_NO_WIN) {
                this.module.updateManager.addTimer(() => {
                    this.emit(GenericPopupEvents.INTRO_STARTED, GenericPopupType.FREESPIN_OUTRO);
                    this.emit(GenericPopupEvents.FADE_OUT_STARTED, GenericPopupType.FREESPIN_OUTRO);
                    this.emit(GenericPopupEvents.POPUP_CLOSED, GenericPopupType.FREESPIN_OUTRO);

                    strictGameEmitter.emit('Generic.POPUP.INTRO_STARTED', this.view.getPopupEmitType());
                    strictGameEmitter.emit('Generic.POPUP.FADE_OUT_STARTED', this.view.getPopupEmitType());
                    strictGameEmitter.emit('Generic.POPUP.POPUP_CLOSED', this.view.getPopupEmitType());
                }, 500, true);
            } else {
                consoleLogger.warn(`cannot find popupConfig to ${type.toString()}`);
            }
        } else {
            this.showPopup(config);
        }
    }
}
